var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_61_18008",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_61_18008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7557 11.375L7.85566 15.275C7.67233 15.4583 7.439 15.55 7.15566 15.55C6.87233 15.55 6.639 15.4583 6.45566 15.275C6.27233 15.0917 6.18066 14.8583 6.18066 14.575C6.18066 14.2917 6.27233 14.0583 6.45566 13.875L11.0557 9.275C11.1557 9.175 11.264 9.10417 11.3807 9.0625C11.4973 9.02083 11.6223 9 11.7557 9C11.889 9 12.014 9.02083 12.1307 9.0625C12.2473 9.10417 12.3557 9.175 12.4557 9.275L17.0557 13.875C17.239 14.0583 17.3307 14.2917 17.3307 14.575C17.3307 14.8583 17.239 15.0917 17.0557 15.275C16.8723 15.4583 16.639 15.55 16.3557 15.55C16.0723 15.55 15.839 15.4583 15.6557 15.275L11.7557 11.375Z",
    fill: "#454E58"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.76f96df155cb5ecf290d52a464ae7435.svg";
export { ForwardRef as ReactComponent };